Customer.Users ||= {}

class Customer.Users.ProfileTagsView extends Backbone.View
  template: JST['backbone/templates/customer/users/profile_tags']

  className: 'processing main-profile-section main-profile-tags'

  events:
    'change select.tags': 'onAdd'
    'click button.tag': 'onToggle'
    'click .edit-profile-tags': 'editModeOn'
    'click #done button': 'onSave'
    'click #cancel button': 'onCancel'

  initialize: (@options = {}) ->
    @profile = @options.profile
    @allPossibleTags = new Collections.UserProfileTagCollection
    @appliedTags = []
    @updateAppliedTags()
    @loadPossibleTags()
    @tagsLoaded = false

  render: =>
    @$el.html(@template(@))
    @initializeChosen()
    return this

  editModeOn: ->
    @$el.find('.tags-editor').addClass('active') if @allPossibleTags.length > 0
    @$el.find('.applied_tags button').attr('disabled', false)

  editModeOff: ->
    @$el.find('.tags-editor').removeClass('active')
    @$el.find('.applied_tags button').attr('disabled', true)

  onCancel: =>
    @revertTags()
    @render()

  initializeChosen: ->
    select = @$el.find('select.tags')
    select.chosen(width: '200px', search_contains: true)
    chosenDrop = @$el.find('.chosen-drop').hide()
    select.on('chosen:showing_dropdown', ->
      chosenDrop.show()
    )
    select.on('chosen:hiding_dropdown', ->
      chosenDrop.hide()
    )

  loadPossibleTags: =>
    @allPossibleTags.fetch
      success: (response) =>
        @$el.removeClass('processing')
        @tagsLoaded = true
        @render()
      error: (response) =>
        console.log('An error has occurred trying to fetch tags')

  possibleTags: ->
    _.sortBy(
      @allPossibleTags.pluck('description'),
      (description) -> description.toLowerCase()
    )

  mainTags: ->
    return @possibleTags().filter (tag) =>
       @isMainTag(tag)

  hasTag: (tag) ->
    @arrayHasTag(@tags(), tag)

  isMainTag: (tag) ->
    @hasTag(tag)

  arrayHasTag: (array, tag) ->
    tag = tag || {}
    description = tag.description || ''
    code = tag.code || ''
    _.intersection(array, [tag, tag.description, tag.code]).length > 0

  tags: ->
    @profile.tags

  unappliedTags: ->
    @possibleTags().filter (tag) =>
      !@isMainTag(tag)

  onToggle: (evt) =>
    target = $(evt.currentTarget)
    clientCode = target.text()
    tag = _.find(@possibleTags(), (t) -> t == clientCode)
    if target.hasClass('active')
      @profile.tags = _.without(@profile.tags, tag)
    else
      @profile.tags.push(tag)

  onAdd: (evt) =>
    target = $(evt.currentTarget)
    clientCode = target.val()
    tag = _.find(@possibleTags(), (t) -> t == clientCode)
    @addNewButton(tag)
    @profile.tags.push(tag)

  onSave: =>
    @updateAppliedTags()
    @render()
    @trigger('changedTags', @profile.tags) # This line does nothing
    # TODO refactor
    data = { profile_id: @profile.id, profile_tags_updated: true, profile_tags: @profile.tags }
    $.ajax
      type: 'POST'
      url: "/profiles/api/update"
      data: data
      success: (response) =>
        console.log('Saved tags successfully')
      error: (response) =>
        console.log('Error saving tags')

  updateAppliedTags: =>
    @appliedTags = []
    @appliedTags.push(tag) for tag in @profile.tags

  revertTags: =>
    @profile.tags = []
    @profile.tags.push(tag) for tag in @appliedTags

  sortSelectOptions: ->
    options = _.sortBy(@$el.find('select option'), (option) -> option.text)
    @$el.find("select").html(options).val('').trigger("chosen:updated")

  addNewButton: (tag) ->
    newButton = $("<button type='button' class='tag btn nohover btn-mini active' data-toggle='button' data-code='#{tag}'>#{tag}</button>")

    @$el.find("option[value='#{tag}']").remove()
    @$el.find("select").trigger("chosen:updated")
    buttons = @$el.find('.applied_tags button')

    if buttons.length == 0
      @$el.find('.applied_tags').append(newButton)
    else if buttons.last().text() < tag
      buttons.last().after(newButton)
    else
      for button in buttons
        if tag < $(button).text()
          $(button).before(newButton)
          break
